$(document).ready(function(){
  $('slideshow-component .slideshow').slick({
    dots: true,
    arrows: true,
    prevArrow: $('slideshow-component .slideshow_slider_arrows .slider-button--prev'),
    nextArrow: $('slideshow-component .slideshow_slider_arrows .slider-button--next'),
    touchThreshold: 20
  });

  $('.testimonials-section .testimonials-wrapper').slick({
    dots: true,
    arrows: false,
    touchThreshold: 20,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.logo-wrapper-section .logo-list').slick({
    dots: false,
    arrows: false,
    touchThreshold: 20,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,            
    speed: 5000,                
    autoplay: true,
    autoplaySpeed: 0,          
    pauseOnHover: true,
    cssEase: 'linear', 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

});